/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Separate_Dates_OffInputs */

const fr_label_separate_dates_off = /** @type {(inputs: Label_Separate_Dates_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivé`)
};

const en_label_separate_dates_off = /** @type {(inputs: Label_Separate_Dates_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled`)
};

/**
* | output |
* | --- |
* | "Disabled" |
*
* @param {Label_Separate_Dates_OffInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_separate_dates_off = /** @type {((inputs?: Label_Separate_Dates_OffInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Separate_Dates_OffInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_separate_dates_off(inputs)
	return en_label_separate_dates_off(inputs)
});